import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Tabs } from "@mwi/ui";
import { useSelector } from "react-redux";
import { RootState } from "store";

const PracticeSettingsLayout = (): JSX.Element => {
  const location = useLocation();

  const user = useSelector((state: RootState) => state.auth.user);

  if (location.pathname === "/admin/settings") {
    return <Navigate to="/admin/settings/appointments" replace />;
  }

  return (
    <>
      <div className="mb-12">
        <h1 className="text-[28px] leading-[34px] tablet:text-5xl tablet:leading-[58px]">
          Settings
        </h1>
      </div>

      <Tabs className="gap-x-10">
        <Tabs.Item
          className="h-[35px]"
          title="Appointments"
          isActive={location.pathname === "/admin/settings/appointments"}
          to="/admin/settings/appointments"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Features"
          isActive={location.pathname === "/admin/settings/features"}
          to="/admin/settings/features"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Admin Users"
          isActive={location.pathname === "/admin/settings/user-management"}
          to="/admin/settings/user-management"
        />

        <Tabs.Item
          className="h-[35px]"
          title="Clients"
          isActive={location.pathname === "/admin/settings/owner-management"}
          to="/admin/settings/owner-management"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Practitioners"
          isActive={location.pathname === "/admin/settings/practitioners"}
          to="/admin/settings/practitioners"
        />
      </Tabs>

      <div className="flex flex-col flex-grow py-12">
        <Outlet />
      </div>
    </>
  );
};

export default PracticeSettingsLayout;
